import { Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import {
    chipRow,
    type InvoiceStatusRow,
    operationLabelKey,
    providerReference,
    statusColor,
    statusLabelKey,
} from '../../domain/eInvoice';

/**
 * The e-Factura state of one invoice in a list of another page (plan §7.3). A dash while the
 * invoice has no row (older than the start date, or a type that is never sent). The caller adds
 * the column only when the module is available, see `useEInvoiceStatuses`.
 */
export default function EInvoiceStatusChip({
    rows,
}: Readonly<{ rows: readonly InvoiceStatusRow[] | undefined }>) {
    const { t } = useTranslation();
    const row = chipRow(rows);

    if (row === null) {
        return <span>-</span>;
    }

    const reference = providerReference(row);
    const detail = [t(operationLabelKey(row.operation)), reference].filter(Boolean).join(' · ');

    return (
        <Tooltip title={detail}>
            <Tag
                color={statusColor(row.status)}
                data-testid={`e-invoice-chip-${row.invoiceId}-${row.status}`}
            >
                {t(statusLabelKey(row.status))}
            </Tag>
        </Tooltip>
    );
}
